import { connect } from 'react-redux'
import { selectors as reportsSelectors } from 'store/reportsManager'
import UserProgressRow from './component'

const mapStateToProps = (state, { practiceType, siteId, user }) => {
  const rowData = reportsSelectors.createHsUserProgressTableDataBySiteAndUserId(
    state,
    siteId,
    user.userId,
    practiceType,
  )

  return {
    user: {
      ...user,
      rowData,
    },
  }
}

export default connect(mapStateToProps, null)(UserProgressRow)
